import React, { useState, useRef, useEffect } from "react";
import { MinaCaja } from "../components/ingresos/modalMinaCaja";
import { OtrosImpuestos } from "../components/ingresos/modalOtroPago";
import PagosRegistros from "../components/ingresos/registrarpagos";
import axios from "axios";
import { Dimmer } from "../components/spinner";
import { Mensaje } from "../components/mensajes";
import moment from "moment";

function CajaIngresos() {
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [idtipoimpuesto, setIdtipoimpuesto] = useState(null);
  const [idtipoimpuestos, setIdtipoimpuestos] = useState(null);
  const [campo, setCampo] = useState(null);
  const [valor, setValor] = useState(null);
  const [facturas, setFacturas] = useState([]);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const numcaja = JSON.parse(localStorage.getItem("numcaja"));
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const radioFactu = useRef();
  const radioVerifi = useRef();
  const [activo, setActivo] = useState(false);

  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  useEffect(() => {
    radioFactu.current.checked = true;
    radioVerifi.current.checked = false;
    seleccionarFacturas();
  }, []);

  const cargarpago = (tipo, campo, valor) => (e) => {
    e.preventDefault();
    if (numcaja === "" || numcaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuesto(tipo);
    setCampo(campo);
    setValor(valor);
    setMostrar(true);
  };

  const cargarotropago = (tipo) => (e) => {
    e.preventDefault();
    if (numcaja === "" || numcaja === null) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Usuario no Tiene Número de Caja Asignado",
        icono: "error",
      });
      return;
    }
    setIdtipoimpuestos(tipo);
    setMostrar2(true);
  };

  const seleccionarFacturas = () => {
    let campos = "*";
    let nomtab = "factura";
    let fe = "'" + moment(fechaSistema).format("YYYY-MM-DD") + "'";
    let sta = 0;
    let condi = "";
    if (radioFactu.current.checked) {
      condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
    } else {
      let letra = "'V'";
      condi = ` substring(numfactura, 1, 1) = ${letra} AND status = ${sta}`;
    }

    let orden = "1";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFacturas(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);

        //setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleAceptaFactura = () => {
    setMostrar(false);
    seleccionarFacturas();
  };

  const handleAceptaOtroPago = () => {
    setMostrar2(false);
    seleccionarFacturas();
  };

  const handleChangeRadio = (event) => {
    if (event.target.name === "radioTipo") {
      if (radioFactu.current.checked) {
        setActivo(false);
      } else if (radioVerifi.current.checked) {
        setActivo(true);
      }
    }

    seleccionarFacturas();
  };

  return (
    <div>
      <div className="row m-0 p-0">
        <div className="col-md-2 col-2 amanecergris p-0 m-0 tmenu">
          <div className="">
            <div className="list-group list-group-flush">
              <ul className="list-group list-group-light">
                <li
                  onClick={cargarpago("expendedores", "expendedor", true)}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-ticket-alt fa-fw me-3 text-light"></i>
                    <span className="text-dark text-secondary fw-bold oculto">
                      Timbres
                    </span>
                  </a>
                </li>
                <li
                  onClick={cargarpago("minas", "mina", true)}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-truck-loading fa-fw me-3 second-text" />
                    <span className="text-dark text-secondary fw-bold oculto">
                      Minas
                    </span>
                  </a>
                </li>
                <li
                  onClick={cargarpago("produccion", "produccion", true)}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-hard-hat fa-fw me-3 text-success " />
                    <span className="text-dark text-secondary fw-bold oculto">
                      Produccion
                    </span>
                  </a>
                </li>
                <li
                  onClick={cargarpago("1x500", "impuesto1x500", true)}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-chalkboard-teacher fa-fw me-3 text-info" />
                    <span className="text-dark text-secondary fw-bold oculto">
                      1x1000
                    </span>
                  </a>
                </li>
                <li
                  onClick={cargarpago("rentas", "idtipoagente", "6")}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-industry fa-fw me-3 text-warning" />
                    <span className="text-dark text-secondary fw-bold oculto">
                      Rentas
                    </span>
                  </a>
                </li>
                <li
                  onClick={cargarotropago(
                    "Impresión de Factura - Otros Impuestos",
                    true
                  )}
                  className="list-group-item bg-transparent"
                  style={{
                    pointerEvents: activo === true ? "none" : false,
                    color: activo ? "rgb(183, 183, 183)" : "#1d0345",
                    backgroundColor: activo
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                  }}
                >
                  <a
                    className="btn-primary  list-group-item list-group-item-action py-2 ripple bg-transparent"
                    type="button"
                  >
                    <i className="fas fa-piggy-bank fa-fw me-3 text-primary" />
                    <span className="text-dark text-secondary fw-bold oculto">
                      Otros Ingresos
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-10 col-10" id="scroll">
          <div className="row m-0 col-10 py-2">
            <div className="col-sm-1"></div>
            <div className="form-check col-sm-2">
              <input
                className="form-check-input"
                type="radio"
                ref={radioFactu}
                name="radioTipo"
                id="radioFactura"
                onChange={handleChangeRadio}
              />
              <label className="form-check-label" htmlFor="exampleRadios1">
                Procesar Facturas
              </label>
            </div>
            <div className="form-check col-sm-3">
              <input
                className="form-check-input"
                type="radio"
                ref={radioVerifi}
                name="radioTipo"
                id="radioVerifica"
                onChange={handleChangeRadio}
              />
              <label className="form-check-label" htmlFor="exampleRadios2">
                Procesar Verificaciones
              </label>
            </div>
          </div>

          <MinaCaja
            show={mostrar}
            tipo={idtipoimpuesto}
            campo={campo}
            valor={valor}
            onHideCancela={() => setMostrar(false)}
            onHideAcepta={handleAceptaFactura}
          />

          <OtrosImpuestos
            show={mostrar2}
            tipo={idtipoimpuestos}
            onHideCancelar={handleAceptaOtroPago}
          />

          <PagosRegistros
            facturas={facturas}
            onHideRenderizar={seleccionarFacturas}
            tipo={radioFactu.current && radioFactu.current.checked ? 1 : 2}
          />
        </div>
      </div>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </div>
  );
}

export default CajaIngresos;



// WEBPACK FOOTER //
// ./src/pages/cajaingresos.js